import api from '@/services/api';

export default {
  async fetchUserByEmail(email: string) {
    return api.fetch(`/users?email=${email}`, 'GET');
  },
};
